import "core-js/modules/es.array.concat.js";

/*
 * @Author       : Qoder
 * @Date         : 2026-07-23
 * @LastEditors  : Qoder
 * @FilePath     : /marketing-landing-fe/src/modules/landing/CustomerServiceButton/index.ts
 * @Description  : 落地页客服入口组件（moduleType=16），支持 inline/standalone 两种模式
 */
import './index.less';
import customIcon from '@/assets/icons/custom.png';
import { isDouDou, isJoJoUp, isZZX } from '@/const';
import { _trans } from '@/lib/i18next';
import { reportError } from '@/utils';
import { exposureModule, sensClick } from '@/utils/sensors';
/** 客服跳转路径，按 App 环境区分 */

var CUSTOMER_SERVICE_PATH_MAP = {
  jojoup: 'https://pages.mohezi.cn/fb/pagani/api/pagani/view/jingtan/chat?origin=JOJOUP_luodiye&channel=485347207&channelId=6686171',
  zzx: 'https://api.zzx.cdyanhezi.cn/fb/pagani/api/pagani/view/jingtan/chat?origin=xjs_luodiye&channel=700969973&channelId=8143285',
  doudou: 'https://pages.dd.shushengdu.com/fb/pagani/api/pagani/view/jingtan/chat?origin=doudou_luodiye&channel=700968453&channelId=8144260',
  jojo: 'https://jojoread.tinman.cn/read/plan/plan/customerCenter'
};

function getCustomerServicePath() {
  if (isZZX) return CUSTOMER_SERVICE_PATH_MAP.zzx;
  if (isJoJoUp) return CUSTOMER_SERVICE_PATH_MAP.jojoup;
  if (isDouDou) return CUSTOMER_SERVICE_PATH_MAP.doudou;
  return CUSTOMER_SERVICE_PATH_MAP.jojo;
}

function getInlineTpl(moduleResp) {
  var _a = moduleResp.moduleContent,
      moduleContent = _a === void 0 ? '' : _a,
      _b = moduleResp.moduleLink,
      moduleLink = _b === void 0 ? '' : _b;
  var targetUrl = moduleLink || getCustomerServicePath();

  var text = moduleContent || _trans('customerService.inline');

  return (
    /* html */
    "\n    <button\n      id=\"j-customer-service-inline\"\n      class=\"customer-service__inline\"\n      data-element_name=\"\u6295\u653E\u843D\u5730\u9875_\u5BA2\u670D\u6309\u94AE\"\n      data-element_content=\"".concat(text, "\"\n      data-element_target_url=\"").concat(targetUrl, "\"\n      data-activity_label=\"\u6295\u653E\"\n    >\n      <img class=\"customer-service__icon\" src=\"").concat(customIcon, "\" alt=\"\u5BA2\u670D\" />\n      <span class=\"customer-service__text\">").concat(text, "</span>\n    </button>\n  ")
  );
}

function getStandaloneTpl(moduleResp) {
  var _a = moduleResp.moduleContent,
      moduleContent = _a === void 0 ? '' : _a,
      _b = moduleResp.moduleLink,
      moduleLink = _b === void 0 ? '' : _b;
  var targetUrl = moduleLink || getCustomerServicePath();

  var text = moduleContent || _trans('customerService.standalone');

  return (
    /* html */
    "\n    <section class=\"customer-service__panel\">\n      <button\n        id=\"j-customer-service-standalone\"\n        class=\"customer-service__standalone\"\n        data-element_name=\"\u6295\u653E\u843D\u5730\u9875_\u5BA2\u670D\u6309\u94AE\"\n        data-element_content=\"".concat(text, "\"\n        data-element_target_url=\"").concat(targetUrl, "\"\n        data-activity_label=\"\u6295\u653E\"\n      >\n        <img class=\"customer-service__icon\" src=\"").concat(customIcon, "\" alt=\"\u5BA2\u670D\" />\n        <span class=\"customer-service__text\">").concat(text, "</span>\n      </button>\n    </section>\n  ")
  );
}

var CustomerServiceButtonModule = function () {
  function CustomerServiceButtonModule() {
    this.config = null;
  }

  CustomerServiceButtonModule.prototype.render = function (config) {
    this.config = config;
    var mode = config.mode,
        moduleResp = config.moduleResp;

    if (mode === 'inline') {
      return getInlineTpl(moduleResp);
    }

    return getStandaloneTpl(moduleResp);
  };

  CustomerServiceButtonModule.prototype.mount = function ($root, _a) {
    var _this = this;

    var _b = _a === void 0 ? {} : _a,
        module = _b.module;

    var inlineBtn = document.getElementById('j-customer-service-inline');
    var standaloneBtn = document.getElementById('j-customer-service-standalone');
    var btn = inlineBtn || standaloneBtn;

    var handleClick = function handleClick(e) {
      var _a;

      sensClick(e);

      try {
        var _b = (((_a = _this.config) === null || _a === void 0 ? void 0 : _a.moduleResp) || {}).moduleLink,
            moduleLink = _b === void 0 ? '' : _b;
        var url = moduleLink || getCustomerServicePath();
        window.location.href = url;
      } catch (err) {
        reportError(err);
      }
    };

    if (inlineBtn) {
      inlineBtn.onclick = handleClick;
    }

    if (standaloneBtn) {
      standaloneBtn.onclick = handleClick;
    }

    if (btn) {
      exposureModule(btn, {
        module: module
      });
    }
  };

  return CustomerServiceButtonModule;
}();

export default new CustomerServiceButtonModule();